import { motion } from 'framer-motion';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Variant.module.css';

export const Variant = ({
  item,
  index,
  isQuestionImg,
  isStateCorrectVar,
  aciveAmimate,
  delayVariant,
}) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  // анимация правильного варианта
  const titleVariants = {
    inactive: {
      color: '#232323',
      backgroundColor: '#ffffff',
      transition: { duration: 0.5 },
    },
    active: {
      color: [
        '#232323',
        '#232323',
        '#232323',
        '#ffffff',
        '#ffffff',
        '#072455',
        '#ffffff',
        '#072455',
        '#ffffff',
      ],
      backgroundColor: [
        '#ffffff',
        '#ffffff',
        '#ffffff',
        '#E8254A',
        '#018347',
        '#ffffff',
        '#018347',
        '#ffffff',
        '#018347',
      ],
      times: [0, 0.3, 0.6, 0.68, 0.68, 0.76, 0.84, 0.92, 1],
      transition: { duration: 3.4 },
    },
  };

  const numberVariants = {
    inactive: {
      backgroundColor: '#b11900',
      transition: { duration: 0.5 },
    },
    active: {
      backgroundColor: [
        '#b11900',
        '#0047B1',
        '#072455',
        '#E8254A',
        '#018347',
        '#072455',
        '#018347',
        '#072455',
        '#018347',
      ],
      times: [0, 0.3, 0.6, 0.68, 0.68, 0.76, 0.84, 0.92, 1],
      transition: { duration: 3.4 },
    },
  };

  return (
    <motion.div className={styles.variant}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, delay: delayVariant }}
      >
        <motion.div
          className={styles.varNumber}
          style={{
            fontSize: `${varNumFontSize}rem`,
            height: `${1.5 * varNumFontSize}rem`,
            minWidth: `${1.5 * varNumFontSize}rem`,
          }}
          variants={numberVariants}
          initial="inactive"
          animate={aciveAmimate ? 'active' : 'inactive'}
        >
          {index + 1}
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: delayVariant + 0.4 }}
      >
        <motion.div
          className={styles.varTitle}
          style={{
            fontSize: `${answerFontSize}rem`,
            minHeight: `${1.5 * answerFontSize}rem`,
          }}
          variants={titleVariants}
          initial="inactive"
          animate={aciveAmimate ? 'active' : 'inactive'}
        >
          {item.comment}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
